const NotesSection = ({ register }) => {
  return (
    <div className="bg-light bg-white p-3 rounded shadow-sm mt-4 mb-4">
      <p><strong>NOTES</strong></p>

      <textarea
        {...register("notes")}
        className="form-control"
        rows="3"
        placeholder="Additional notes (optional)"
      />
    </div>
  );
};

export default NotesSection;